import React from "react";
import SystemError from "../organisms/SystemError";
import BasicTemplate from "../templates/BasicTemplate";

function SystemErrorPage() {
  return <BasicTemplate main={<SystemError />} />;
}

export default SystemErrorPage;
